document.addEventListener('DOMContentLoaded', function () {
    // Cache DOM elements
    const avgRatings = document.getElementById('avgRatings');

    document.querySelectorAll('i.stars-color.opw-noci.opw-noci-star-empty').forEach(star => {
        star.closest('.product-ratings')?.style.setProperty('visibility', 'hidden');
        star.closest('#avgRatings')?.style.setProperty('visibility', 'hidden');
    });

    document.querySelectorAll('.avg-review').forEach(avgReviewSpan => {
        let avgRating = avgReviewSpan.textContent.trim().replace(/\.0$/, '');
        const newDiv = document.createElement('div');
        newDiv.className = 'avg-review-updated';
        newDiv.innerHTML = `<span>${avgRating}</span>`;

        const parent = avgReviewSpan.closest('#avgRatings') || avgReviewSpan.closest('.product-ratings');
        parent?.querySelector('.opinew-no-reviews-stars-plugin')?.before(newDiv);
    });
    document.querySelectorAll('.opinew-no-reviews-stars-plugin b').forEach(b => {
        let TotalReviews = b.textContent.trim().replace(/[()]/g, '').replace(/\.0$/, '');
        let newDiv = document.createElement('div');
        newDiv.className = 'total-reviews-updated';
        newDiv.innerHTML = `<span>${TotalReviews} Reviews</span>`;
        const parent = b.closest('#avgRatings') || b.closest('.product-ratings');
        parent?.querySelector('.opinew-no-reviews-stars-plugin')?.before(newDiv);
    });
    // Scroll to ReviewsHolder and open accordion if closed
    if (avgRatings) {
        avgRatings.addEventListener('click', function (event) {
            event.preventDefault();

            const reviewsHolder = document.querySelector('#ReviewsHolder');

            if (reviewsHolder) {
                const targetTop = reviewsHolder.getBoundingClientRect().top + window.scrollY - 200;
                window.scrollTo({ top: targetTop, behavior: 'smooth' });
            }
        });
    }
    // Observe when #opinew_product_plugin_app appears instead of using setInterval
    const observer = new MutationObserver(() => {
        const opinewApp = document.querySelector('#opinew_product_plugin_app');

        if (opinewApp) {
            // Show the reviews button
            document.querySelectorAll('.product_rating .reviews').forEach(element => {
                element.style.display = 'block';
            });

            // Scroll to ReviewsHolder when clicking reviews
            function handleReviewsClick(event) {
                event.preventDefault();

                const reviewsHolder = document.querySelector('#ReviewsHolder');
                if (reviewsHolder) {
                    const targetTop = reviewsHolder.getBoundingClientRect().top + window.scrollY - 200;
                    window.scrollTo({ top: targetTop, behavior: 'smooth' });
                }

                // Optional: Trigger first Opinew tab if available
                const navbarButtons = document.querySelectorAll('.opinew-navbar-button');
                if (navbarButtons.length) {
                    navbarButtons[0].click();
                }
            }

            // Ensure no duplicate listeners
            document.querySelectorAll('.product_rating .reviews').forEach(button => {
                button.removeEventListener('click', handleReviewsClick);
                button.addEventListener('click', handleReviewsClick);
            });

            // Auto-trigger click if URL has write-a-review param
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('q') === 'write-a-review') {
                document.querySelectorAll('.product_rating .reviews').forEach(button => button.click());
            }

            observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

});
